import React from "react";
import Navigation from "../../components/Navigation/Navigation";
import FrontendFooter from "../../components/Layout/FrontendFooter";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <div className="app-container">
      <Navigation />

      <section className="inner-banner text-white">
        <div className="home-container">
          <h1 className="page-title">Terms and Conditions</h1>
          <p>Please read these terms carefully</p>
        </div>
      </section>

      <section className="home-about">
        <Container maxWidth="lg">
          <Box sx={{ py: 6 }}>
            <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: "7px", backgroundColor: "white" }}>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                These Terms and Conditions ("Terms") govern your use of this website and services. By accessing or using the platform, 
                you agree to comply with these Terms. If you do not agree with any part of these Terms, you should not access the services.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                1. Acceptance of Terms
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                By accessing and using this website, you accept and agree to be bound by these Terms. If you do not agree, 
                you should discontinue use of the service immediately.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                2. Use License
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                You are granted a limited license to temporarily download one copy of the materials on the website for personal, 
                non-commercial use only. Under this license, you may not:
              </Typography>
              <Box component="ul" sx={{ pl: 3, mb: 3 }}>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  Modify or copy the materials
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  Use the materials for commercial purposes or public display
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  Attempt to reverse engineer any software
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  Remove any proprietary notations
                </Typography>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                3. User Account
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                You are responsible for maintaining the confidentiality of your account and password and for restricting access 
                to your device. You agree to accept responsibility for all activities that occur under your account.
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                You agree not to use the platform to transmit any harmful or unlawful content.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                4. Intellectual Property Rights
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                All content and materials on the platform are the intellectual property of the platform owner or licensors, 
                and are protected by applicable intellectual property laws.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                5. Privacy Policy
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                Your use of the platform is also governed by our Privacy Policy, which outlines how your information is collected, 
                used, and protected.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                6. Limitation of Liability
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                We shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your 
                use or inability to use the service.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                7. Termination
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                We may terminate or suspend your access immediately without prior notice or liability for any reason, 
                including breach of the Terms.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                8. Governing Law
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                These Terms shall be governed and interpreted in accordance with the applicable laws of the governing jurisdiction.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                9. Changes to Terms
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                We may update or revise these Terms at any time without prior notice. Changes will take effect upon posting on the website.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                10. Contact
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                If you have questions regarding these Terms and Conditions, please reach out through the contact details provided on the website.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="body2" sx={{ color: "#666", fontStyle: "italic" }}>
                By continuing to use our services, you acknowledge and agree to be bound by these Terms and Conditions.
              </Typography>
            </Paper>
          </Box>
        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default TermsAndConditions;
